import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdClose, MdLogin, MdMenu, MdPersonAdd } from 'react-icons/md';
import ThemeToggle from '../ThemeToggle';
import LanguageSelector from '../LanguageSelector';
import { t } from '../../utils/i18n';
import logoImage from '../../assets/babysit_logo.png';

export default function LandingHeader({ onOpenAuth }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAuth = (mode) => {
    setIsMobileMenuOpen(false);
    onOpenAuth(mode);
  };

  return (
    <header className="landing-header sticky top-0 z-50">
      <nav className="landing-container h-[72px] flex justify-between items-center gap-4">
        <Link to="/" className="flex items-center gap-2.5 min-w-0">
          <img
            src={logoImage}
            alt="Nannity"
            className="h-9 w-auto flex-shrink-0"
          />
          <span className="text-lg font-semibold text-[var(--color-text)] tracking-tight truncate">
            Nannity
          </span>
          <span className="hidden xl:inline text-[11px] font-medium text-[var(--color-text-muted)] tracking-wide">
            {t('landing.header.badge')}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <LanguageSelector />
          <ThemeToggle />
          <button
            type="button"
            onClick={() => onOpenAuth('login')}
            className="landing-btn-secondary ml-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40"
          >
            {t('landing.header.login')}
          </button>
          <button
            type="button"
            onClick={() => onOpenAuth('register')}
            className="landing-btn-primary ml-1 px-4 py-2 text-sm font-semibold rounded-lg transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/50"
          >
            {t('landing.header.register')}
          </button>
        </div>

        <div className="md:hidden flex items-center gap-1">
          <ThemeToggle />
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="p-2 rounded-lg landing-btn-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40"
            aria-label={t('nav.accountMenu')}
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <MdClose className="text-xl" /> : <MdMenu className="text-xl" />}
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-[var(--color-border)] landing-header-menu">
          <div className="landing-container py-3 space-y-2">
            <div className="flex items-center justify-between py-2">
              <span className="text-sm text-[var(--color-text-muted)]">{t('nav.language')}</span>
              <LanguageSelector />
            </div>
            <button
              type="button"
              onClick={() => handleAuth('login')}
              className="w-full landing-btn-secondary py-2.5 text-sm font-medium rounded-lg"
            >
              {t('landing.header.login')}
            </button>
            <button
              type="button"
              onClick={() => handleAuth('register')}
              className="w-full landing-btn-primary py-2.5 text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
            >
              {t('landing.header.register')}
              <MdPersonAdd className="text-lg" />
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
